/**
 * @description 产品业务打点模块
 * @author duanjun
 * @date 2017.03.29
 */

import { $window } from '@umu/umu-dom';
import { ILearningTimeLogParams } from '@umu/umu-types';
import { services } from 'common';
const { getModuleData } = services;
import { cookieHelper } from '@umu/umu-storage';
import { PageVisibility } from './pageVisibility';
// umu_page: p (1:session 2:group 3:program 4:学习群 5:app首页tab 6:我参与的 7:错题集)
// from: f.   (pc: 1, m: 2,ios:3,android:4)
// session_id: sid
// group_id: gid

// program_id: pid

export enum P {
    SESSION = '1', // session
    GROUP = '2', // group
    PROGRAM = '3', // program
    LEARNING_CHAT = '4', // 学习群
    APP_HOME = '5', // app首页tab
    MY_PARTICIPATING = '6', // 我参与的
    QUESTION_COLLECTION = '7', // 错题集
    PLAN_PRICING = '8', // 8.升级页面
    PLAN_UPGRADE = '9', // 9.订单页面
}

declare global {
    interface Window {
        aegis: any;
    }
}

function errorEventReport(args: any, e: Event | string) {
    const userInfo = getModuleData('userInfo');
    if (window.aegis) {
        try {
            window.aegis.reportEvent({
                name: 'sendLearningTimeEvent error log', // 必填
                ext1: args.sid + '-' + userInfo.umu_id,
                ext2: JSON.stringify(args),
                ext3: JSON.stringify(e),
            });
        } catch (error) {
            console.log(error);
        }
    }
}

const PAGE_TOKEN = `${Date.now()}`;
const logId = cookieHelper && cookieHelper.get('estuid');

const productionLog = {
    timerId: 0,
    param(obj: Record<string, any>) {
        const params = [];
        for (const key in obj) {
            if (obj.hasOwnProperty(key) && obj[key] !== undefined) {
                params.push(escape(key) + '=' + escape(obj[key] || ''));
            }
        }
        return params.join('&').replace(/%20/g, '+');
    },

    getDeviceType() {
        const ua = navigator.userAgent;
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
        const isUMUWebview = /umu/.test(ua);
        let type;
        // app
        if (isUMUWebview) {
            const isIos = ua && /(iphone|ipad|ipod|ios)/i.test(ua);
            type = isIos ? '3' : '4';
        } else {
            // web
            type = isMobile ? '2' : '1';
        }
        return type;
    },

    log(params: Record<string, any>, onError?: OnErrorEventHandler) {
        if (logId !== cookieHelper.get('estuid')) {
            return;
        }

        let url = 'https://stat.umu.cn/hm.gif';
        url = 'https://stat.umu.co/hm.gif';

        const hostMatch = location.hostname.match(/^(?:m\.)?([^\.]+)\./);
        const host = (hostMatch && hostMatch[1]) || 'app';
        url = `http://stat.${host}.umucdn.cn/hm.gif`;
        // 线下环境增加开关@daoyu @liyue
        if (false && $window.location.href.indexOf('debug_learningtime=1') === -1) {
            url = '';
        } else {
            console.warn('log', params, new Date().toLocaleTimeString());
        }

        // dev环境
        if (location.host.indexOf('dev.umucdn.cn') > -1) {
            url = 'http://stat.dev.umucdn.cn/hm.gif';
        }
        if (!url) {
            return;
        }
        let img: HTMLImageElement | null = new Image();
        params.timestamp = new Date().getTime();
        img.src = url + '?' + productionLog.param(params);
        img.onerror = onError ? onError : null;
        img.onload = () => {
            img = null;
        };
    },

    lastLogListener() {
        if (productionLog.isLogging()) {
            productionLog.log(productionLog.preLogParam);
        }
    },

    preLogParam: {},
    // 修改 https://app.asana.com/0/51340828583966/1199978431316853
    intervalLog(data: object, wait: number = 15) {
        productionLog.log(data);
        wait = parseInt(String(wait), 10);
        productionLog.preLogParam = data;
        if (wait) {
            this.timerId = window.setInterval(() => {
                productionLog.log(data);
            }, wait * 1000);
        }

        addEventListener('beforeunload', productionLog.lastLogListener);
    },

    isLogging() {
        return this.timerId > 0;
    },

    stopLog() {
        if (this.timerId) {
            window.clearInterval(this.timerId);
            this.timerId = 0;
        }
    },

    sessionPageTimer(sessionId: number, groupId: number, enterpriseId: string, wait: number = 30, page?: string) {
        const data: any = {
            p: '1',
            f: productionLog.getDeviceType(),
            sid: sessionId,
            gid: groupId,
            eid: enterpriseId,
        };
        if (page) {
            data.refresh_ts = page;
        }

        productionLog.intervalLog(data, wait);

        PageVisibility.create(`${sessionId}`, (_e: Event, visibilityState: string) => {
            if (visibilityState === 'hidden') {
                this.stopLog();
            } else {
                productionLog.intervalLog(data, wait);
            }
        });
    },

    /**
     * fixme: 2018-11-20 从名字来看是音视频学习时长的打点，为什么文章文档也在用这个打点？？
     * 音频视频的动作的打点，需要增加一个action和页面标识refresh_ts
     * action: start, pause, resume, end
     */
    // tslint:disable-next-line:max-line-length
    audioVideoSessionActionLog(props: ILearningTimeLogParams) {
        if (props) {
            const { sessionId, groupId, enterpriseId, action, page, currentTime } = props;
            const data = {
                p: '1',
                f: productionLog.getDeviceType(),
                sid: sessionId,
                gid: groupId,
                eid: enterpriseId,
                action,
                cTime: Math.floor(currentTime || 0),
                refresh_ts: page || PAGE_TOKEN,
            };
            productionLog.log(data, (e) => {
                errorEventReport(data, e);
            });
        }
    },

    groupPageTimer(groupId: number, enterpriseId: string, wait: number = 30) {
        const data = {
            p: '2',
            f: productionLog.getDeviceType(),
            gid: groupId,
            eid: enterpriseId,
        };
        productionLog.intervalLog(data, wait);
    },

    chatPageTimer(groupId: number, enterpriseId: string, wait: number) {
        const data = {
            p: '4',
            f: productionLog.getDeviceType(),
            pid: groupId,
            eid: enterpriseId,
        };
        productionLog.intervalLog(data, wait);
    },

    programPageTimer(programId: number, enterpriseId: string, wait: number) {
        const data = {
            p: '3',
            f: productionLog.getDeviceType(),
            pid: programId,
            eid: enterpriseId,
        };
        productionLog.intervalLog(data, wait);
    },

    questionCollectionPageTimer(enterpriseId: string, wait: number) {
        const data = {
            p: '7',
            f: productionLog.getDeviceType(),
            eid: enterpriseId,
        };
        productionLog.intervalLog(data, wait);
    },

    planPricingPageTimer(enterpriseId: string, wait: number = 30) {
        const data = {
            p: P.PLAN_PRICING,
            f: productionLog.getDeviceType(),
            eid: enterpriseId || '',
        };
        productionLog.intervalLog(data, wait);
    },

    planUpgradePageTimer(enterpriseId: string, wait: number = 30) {
        const data = {
            p: P.PLAN_UPGRADE,
            f: productionLog.getDeviceType(),
            eid: enterpriseId || '',
        };
        productionLog.intervalLog(data, wait);
    },
};

export default productionLog;
